import { getLoacaledStr } from "@/i18n.js";

function getFloorStr(locale, floorType, localAddressFloor) {
    if (floorType == "OTHER") {
        return "";
    }

    if (floorType == "R/C") {
        if (locale == "zh") {
            return getLoacaledStr(locale, `FLOOR_TYPE_${floorType}`);
        } else {
            return "R/C";
        }
    }

    let floorStr = "";
    if (localAddressFloor != "") {
        const floorTypeStr =
            locale == "zh"
                ? getLoacaledStr(locale, `FLOOR_TYPE_${floorType}`)
                : " ANDAR";
        floorStr = localAddressFloor + floorTypeStr;
    }
    return floorStr;
}

function getUnitStr(locale, unitType, localAddressUnit) {
    if (unitType == "OTHER") {
        return "";
    }
    if (localAddressUnit == "") {
        return "";
    }
    if (locale == "zh") {
        return (
            localAddressUnit + getLoacaledStr(locale, `UNIT_TYPE_${unitType}`)
        );
    } else {
        return localAddressUnit + "";
    }
}

export function getFloorValue(localAddressFloor, floorType) {
    if (floorType == "OTHER" || floorType == "R/C" || localAddressFloor == '') { return null }
    return localAddressFloor
}

export function getUnitValue(localAddressUnit, unitType) {
    if (unitType == "OTHER" || localAddressUnit == '') { return null }
    return localAddressUnit
}

export function getLocaledFloorAndUnitStr(locale, localAddressFloor, localAddressUnit, floorType, unitType) {

    const floorStr = getFloorStr(locale, floorType, localAddressFloor);
    const unitStr = getUnitStr(locale, unitType, localAddressUnit);

    if (localAddressUnit == "") {
        return floorStr;
    } else if (localAddressFloor == "") {
        if (floorType == "R/C") {
            if (locale == "zh") {
                return floorStr + unitStr;
            } else {
                return floorStr + "-" + localAddressUnit;
            }
        } else {
            return unitStr;
        }
    } else {
        if (locale == "zh") {
            return floorStr + unitStr;
        } else {
            return localAddressFloor + "-" + localAddressUnit;
        }
    }
}


